import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3, _vm$actionsStore$sele4;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "orcamento-list-page",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('ColumnVisibilitySidebar', {
    attrs: {
      "id": _vm.columnSidebarId,
      "module-label": "orçamentos",
      "fields": _vm.fields,
      "visible-fields": _vm.fieldsToShow
    },
    on: {
      "save": _vm.handleSaveFields
    }
  }), _c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Solicitante',
        field: 'solicitante'
      }, {
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'date',
        label: 'Data de validade',
        field: 'dataValidade'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Editando', 'Enviado ao cliente', 'Autorizado', 'Cancelado', 'Não autorizado pelo cliente', 'Visualizado pelo cliente', 'Importado para NFe', 'Importado para OS']
      }]
    }
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "mb-5 orcamento-selection-menu",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.status) != 8 && ((_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.status) != 13 ? _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.atualizarOrcamento",
      modifiers: {
        "atualizarOrcamento": true
      }
    }]
  }, [_vm._v(" Atualizar status ")]) : _vm._e(), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.duplicarOrcamento",
      modifiers: {
        "duplicarOrcamento": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Duplicar Orçamento ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.custoOrcamento",
      modifiers: {
        "custoOrcamento": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Custo do Orçamento ")])], 1) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Customizar colunas',
      expression: "'Customizar colunas'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "border border-muted orcamento-column-button",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$root.$emit('bv::toggle::collapse', _vm.columnSidebarId);
      }
    }
  }, [_c('ToggleSwitchOutline', {
    attrs: {
      "size": 20
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "custoOrcamento",
      "title": "Deseja visualizar o custo do Orçamento selecionado?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "doubleOrcamento",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.custoOrcamento
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("Verificar o custo do Orçamento Número: " + _vm._s((_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele3 === void 0 ? void 0 : _vm$actionsStore$sele3.numero))])]), _c('b-modal', {
    attrs: {
      "id": "duplicarOrcamento",
      "title": "Deseja duplicar o Orçamento selecionado?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "doubleOrcamento",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.duplicar
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("Orçamento a ser duplicado "), _c('p', [_vm._v("Número: " + _vm._s((_vm$actionsStore$sele4 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele4 === void 0 ? void 0 : _vm$actionsStore$sele4.numero))])])]), _c('b-modal', {
    attrs: {
      "id": "atualizarOrcamento",
      "title": "Deseja atualizar o status do(s) Orçamento(s) selecionado(s)?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('div', [_c('b-button', {
          ref: "updateOrcamento",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.atualizarStatus
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("Orçamento(s) para mudar o status "), _c('p', [_vm._v(" Número(s): " + _vm._s(_vm.actionsStore.selectedRows.map(function (os) {
    return os.numero;
  }).join(",")) + " ")])]), _c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.orcamentoStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelected,
      callback: function callback($$v) {
        _vm.statusSelected = $$v;
      },
      expression: "statusSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('TableApp', {
    ref: "orcamentoList",
    attrs: {
      "titulo": "Orçamentos",
      "acaoBtn": "/#/orcamento-novo",
      "textoBtn": "Novo Orçamento",
      "api-url": "/orcamento/lista",
      "fields": _vm.fieldsToShow,
      "classFilterColumn": "numero",
      "perPage": 30,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'solicitante' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "solicitante"
          },
          slot: "solicitante"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.solicitante) + " ")])])]) : _vm._e(), props.field == 'cliente' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.cliente) + " ")])])]) : _vm._e(), props.field == 'valorTotal' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg orcamento-list-total",
          attrs: {
            "slot": "valorTotal"
          },
          slot: "valorTotal"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valorTotal, 2)) + " ")]) : _vm._e(), props.field == 'status' ? _c('span', {
          class: _vm.statusClass(props.rowData.status),
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusLabel(props.rowData.status)) + " ")]) : _vm._e(), props.field == 'dataValidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "dataValidade"
          },
          slot: "dataValidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.dataValidade, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [props.rowData.status !== 4 && props.rowData.status !== 3 && props.rowData.status !== 8 && props.rowData.status !== 13 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Editar orçamento',
            expression: "'Editar orçamento'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.editarOrcamento(props.rowData);
            }
          }
        }, [_c('PencilIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status !== 4 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Copiar Link',
            expression: "'Copiar Link'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          attrs: {
            "placement": "bottom"
          },
          on: {
            "click": function click($event) {
              return _vm.doCopy(props.rowData, props.rowData.id_orcamento);
            }
          }
        }, [_c('Link', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), _vm.checkImpressao(props.rowData) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Gerar Pdf',
            expression: "'Gerar Pdf'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirPDF(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Encaminhar via Whatsapp',
            expression: "'Encaminhar via Whatsapp'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.shareToWhatsapp(props.rowData);
            }
          }
        }, [_c('Whatsapp', {
          attrs: {
            "size": 20
          }
        })], 1), props.rowData.status === 1 && !_vm.store.pafNFCe ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Ver timeline',
            expression: "'Ver timeline'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.openTimeline(props.rowData);
            }
          }
        }, [_c('TimelineClockOutline', {
          attrs: {
            "size": 20
          }
        })], 1)])]) : _vm._e()];
      }
    }])
  }), _c('SendToWppModal', {
    attrs: {
      "openModal": _vm.wppOpenModal,
      "data": _vm.dataToWhatsapp,
      "module": "orcamento"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };